import type { ApiResponse } from '@types';
import { extractErrorMessage } from '@lib/logger/extractErrorMessage.ts';
import { logError } from '@lib/logger/logError.ts';

export function handleError  <T = never> (
  message: string,
  error: unknown,
  source: string
): ApiResponse<T>  {
  const errorMessage = extractErrorMessage(error);

  
  void logError(
    message,
    source,
    {
      error: errorMessage,
      rawError: error,
    },
    false,
  );
  

  return {
    success: false,
    error: {
      message,
      raw: errorMessage,
    },
  };
}